import React from "react";
import Footer from "../../components/footer/Footer";
import Navbar from "./../../components/navbar/Navbar";
import DetailPost from "../../components/post/detailPost/DetailPost";
import "./post.css";
const Post = () => {
  return (
    <div className="post_container">
      <Navbar style={{ position: "static" }} otherPage={true} />
      <DetailPost />
      <Footer />
    </div>
  );
};

export default Post;
